import { Box, Container, Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Articles.css";

const Articles = () => {
  return (
    <div>
      <Container>
        <div className="service">
          <Box className="side_title">
            <Typography variant="h2">Articles</Typography>
          </Box>
          <Grid container spacing={5}>
            <Grid item xs={12} lg={6} md={6}>
              <Box className="articlesCard">
                <Box className="articlesCard_text">
                  <Typography variant="h5">
                    FTL and LTL Explained with Use cases.
                  </Typography>
                  <Typography variant="h5">with Use cases.</Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} lg={6} md={6}>
              <Box className="articlesCard">
                <Box className="articlesCard_text">
                  <Typography variant="h5">
                    12 Common Freight Acronyms You
                  </Typography>
                  <Typography variant="h5"> Need to Know</Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </div>
      </Container>
    </div>
  );
};

export default Articles;
